// API endpoint configuration (replaces public/env.js)
// Only use local emulators if VITE_USE_EMULATORS=true is set (e.g., in .env.local)
// Default dev behavior: hit production APIs (same as original env.js with firebase serve)
const IS_LOCAL = import.meta.env.VITE_USE_EMULATORS === 'true';
const PROD_BASE_URL = 'https://us-central1-binder-browser.cloudfunctions.net';
const LOCAL_HOST = 'localhost';

export const API_ENDPOINTS = {
  // User-managed Want List web API (ADR-0009). The legacy deck `want_list_api`
  // was removed with the deck want list (ADR-0009 retires it).
  want_list: IS_LOCAL ? `http://${LOCAL_HOST}:8103` : `${PROD_BASE_URL}/want_list`,
  // Wants Board (ADR-0011): aggregated group/network wants by supply section.
  wants_board: IS_LOCAL ? `http://${LOCAL_HOST}:8104` : `${PROD_BASE_URL}/wants_board`,
  get_binder_page_v5: IS_LOCAL
    ? `http://${LOCAL_HOST}:8090`
    : `${PROD_BASE_URL}/get_binder_page_v5`,
  sync_api: IS_LOCAL ? `http://${LOCAL_HOST}:8092` : `${PROD_BASE_URL}/sync_api`,
  search_cards: IS_LOCAL ? `http://${LOCAL_HOST}:8093` : `${PROD_BASE_URL}/search_cards`,
  groups_api: IS_LOCAL ? `http://${LOCAL_HOST}:8094` : `${PROD_BASE_URL}/groups_api`,
  group_members_api: IS_LOCAL ? `http://${LOCAL_HOST}:8095` : `${PROD_BASE_URL}/group_members_api`,
  group_invites_api: IS_LOCAL ? `http://${LOCAL_HOST}:8096` : `${PROD_BASE_URL}/group_invites_api`,
  claimed_binders_api: IS_LOCAL
    ? `http://${LOCAL_HOST}:8097`
    : `${PROD_BASE_URL}/claimed_binders_api`,
  pinned_binders_api: IS_LOCAL
    ? `http://${LOCAL_HOST}:8098`
    : `${PROD_BASE_URL}/pinned_binders_api`,
  refresh_profile_api: IS_LOCAL
    ? `http://${LOCAL_HOST}:8101`
    : `${PROD_BASE_URL}/refresh_profile_api`,
  sharing_settings_api: IS_LOCAL
    ? `http://${LOCAL_HOST}:8102`
    : `${PROD_BASE_URL}/sharing_settings_api`,
  discord_oauth: IS_LOCAL ? `http://${LOCAL_HOST}:8100` : `${PROD_BASE_URL}/discord_oauth`,
  updates_api: IS_LOCAL ? `http://${LOCAL_HOST}:8103` : `${PROD_BASE_URL}/updates_api`,
};
